import UserAssignAPI from '~/api/userAssignApi';
import CenteredModal from '~/components/CenteredModal'
import {Fragment, useEffect, useState} from "react";
import { format } from "date-fns";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser, faLock, faEnvelope, faKey} from "@fortawesome/free-solid-svg-icons";
import TablePaging from '~/components/TablePaging';
import WelcomeToSession from "~/pages/default-apps/Home/components/WelcomeToSession";

function AssignUserTab({title}){
    const [showAssignUserModal, setShowAssignUserModal] = useState(false);
    const tablePagingConfig = {
        columns: [
            {
                name: 'USER NAME',
                width: '200px',
                key: 'UserName'
            },
            {
                name: 'EMAIL',
                width: '200px',
                key: 'Email'
            },
            {
                name: 'ASSIGNED DATE',
                width: '200px',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.AssignedDate), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'ACTIVE STATUS',
                width: '150px',
                template: (row) => {
                    return (
                       <span>{row.IsActive ? "Active" : "InActive"}</span>
                    )
                }
            },
            {
                name: 'ACTION',
                width: '120px',
                template: (row) => {
                    return (
                        <a className="fw-semibold" href= "javascript:void(0)"> {row.IsActive ? "InActive Account" : "Active Account"} </a>
                    )
                }
            }
        ],
        url: "/user-assign/user/paged"
    }

    const formField = [
        {label: "USER NAME", icon: faUser},
        {label: "EMAIL", icon: faEnvelope},
        {label: "PASSWORD", icon: faKey},
        {label: "CONFIRM PASSWORD", icon: faKey},
    ]

    const handleAssignNewUser = () => {
        setShowAssignUserModal(true);
    }

    const handleConfirmAssignUser = () => {}

    return (
        <Fragment>
            <div className="mb-6">
                <h4 className="mb-4 text-center">{title}</h4>
                <button type="button" className="btn btn-bt-primary mb-3" onClick={handleAssignNewUser}>Assign New User</button>
                <TablePaging tablePagingConfig={tablePagingConfig}/>
            </div>
            <CenteredModal show={showAssignUserModal} confirmText="Assign User" onConfirm={handleConfirmAssignUser} title="Assign new user" onClose={ () =>  setShowAssignUserModal(false)}>
                <div className="px-4 py-4 pb-0">
                    {
                        formField.map((field, index) => (
                            <div className="form-icon-container mb-4" key={index}>
                                <div className="form-floating">
                                    <input
                                        type="text"
                                        className="form-control text-primary shadow-none form-icon-input"
                                        name={field.label}
                                        placeholder={field.label}
                                    />
                                    <label htmlFor={field.label} className="ext-body-tertiary form-icon-label text-primary">
                                        {field.label}
                                    </label>
                                </div>
                                <FontAwesomeIcon icon={field.icon} className="form-icon fs-9 text-body"/>
                            </div>
                        ))
                    }
                </div>
            </CenteredModal>
        </Fragment>
    )
}
export default AssignUserTab;
